/**
 * CM > IPS > 보안 프로파일 > 인증 기반 방어
 *  - TCP, UDP, DNS, HTTP
 *
 * @since: 2023-11-07
 * @author: jungmin87.kim
 */
import {CmApiPrefix as cmApiPrefix} from '~/utils/restApi'

class TcpData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    this.modelType = 'ads'

    this.ips_prf_id = this.getValue(obj, ['ads_ips_prf_id'], 'ips_prf_id')
    this.auth_action = this.getValue(obj, ['ads_auth_tcp_auth_action_yn'], 'auth_action')
    this.auth_keep_tm = this.getValue(obj, ['ads_auth_tcp_auth_keep_tm'], 'auth_keep_tm')
    this.auth_limit = this.getValue(obj, ['ads_auth_tcp_auth_limit'], 'auth_limit')
    this.auth_wait_tm = this.getValue(obj, ['ads_auth_tcp_auth_wait_tm'], 'auth_wait_tm')
    this.ext_auth_action = this.getValue(obj, ['ads_auth_tcp_ext_auth_action_yn'], 'ext_auth_action')
    this.ext_auth_method = this.getValue(obj, ['ads_auth_tcp_ext_auth_method'], 'ext_auth_method')
    this.ext_auth_use = this.getValue(obj, ['ads_auth_tcp_ext_auth_use_yn'], 'ext_auth_use')
    this.log = this.getValue(obj, ['ads_auth_tcp_log_yn'], 'log')
    this.not_auth_action = this.getValue(obj, ['ads_auth_tcp_not_auth_action_yn'], 'not_auth_action')
    this.not_auth_limit = this.getValue(obj, ['ads_auth_tcp_not_auth_limit'], 'not_auth_limit')
    this.port = this.getValue(obj, ['ads_auth_tcp_port'], 'port')
    this.use = this.getValue(obj, ['ads_auth_tcp_use_yn'], 'use')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(_.get(_.keys(_.pick(obj, [...arr])), 0, arr[0]))
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

class UdpData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    this.modelType = 'ads'

    this.ips_prf_id = this.getValue(obj, ['ads_ips_prf_id'], 'ips_prf_id')
    this.auth_action = this.getValue(obj, ['ads_auth_udp_auth_action_yn'], 'auth_action')
    this.auth_limit = this.getValue(obj, ['ads_auth_udp_auth_limit'], 'auth_limit')
    this.auth_wait_time = this.getValue(obj, ['ads_auth_udp_auth_wait_tm'], 'auth_wait_time')
    this.auth_wait_limit = this.getValue(obj, ['ads_auth_udp_auth_wait_limit'], 'auth_wait_limit')
    this.auth_wait_block = this.getValue(obj, ['ads_auth_udp_auth_wait_block_yn'], 'auth_wait_block')
    this.auth_keep_time = this.getValue(obj, ['ads_auth_udp_auth_keep_tm'], 'auth_keep_time')
    this.port = this.getValue(obj, ['ads_auth_udp_port'], 'port')
    this.log = this.getValue(obj, ['ads_auth_udp_log_yn'], 'log')
    this.use = this.getValue(obj, ['ads_auth_udp_use_yn'], 'use')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(_.get(_.keys(_.pick(obj, [...arr])), 0, arr[0]))
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

class DnsData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    this.modelType = 'ads'

    this.ips_prf_id = this.getValue(obj, ['ads_ips_prf_id'], 'ips_prf_id')
    this.auth_action = this.getValue(obj, ['ads_auth_dns_auth_action_yn'], 'auth_action')
    this.auth_limit = this.getValue(obj, ['ads_auth_dns_auth_limit'], 'auth_limit')
    this.auth_wait_time = this.getValue(obj, ['ads_auth_dns_auth_wait_tm'], 'auth_wait_time')
    this.auth_wait_limit = this.getValue(obj, ['ads_auth_dns_auth_wait_limit'], 'auth_wait_limit')
    this.auth_wait_block = this.getValue(obj, ['ads_auth_dns_auth_wait_block_yn'], 'auth_wait_block')
    this.auth_keep_time = this.getValue(obj, ['ads_auth_dns_auth_keep_tm'], 'auth_keep_time')
    this.check_dns_type = this.getValue(obj, ['ads_auth_dns_check_type'], 'check_dns_type')
    this.check_dns_size_enable = this.getValue(obj, ['ads_auth_dns_check_size_yn'], 'check_dns_size_enable')
    this.check_dns_size = this.getValue(obj, ['ads_auth_dns_check_size'], 'check_dns_size')
    this.log = this.getValue(obj, ['ads_auth_dns_log_yn'], 'log')
    this.use = this.getValue(obj, ['ads_auth_dns_use_yn'], 'use')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(_.get(_.keys(_.pick(obj, [...arr])), 0, arr[0]))
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

class HttpData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    this.modelType = 'ads'

    this.ips_prf_id = this.getValue(obj, ['ads_ips_prf_id'], 'ips_prf_id')
    this.auth_action = this.getValue(obj, ['ads_auth_http_auth_action_yn'], 'auth_action')
    this.auth_keep_tm = this.getValue(obj, ['ads_auth_http_auth_keep_tm'], 'auth_keep_tm')
    this.auth_wait_tm = this.getValue(obj, ['ads_auth_http_auth_wait_tm'], 'auth_wait_tm')
    this.log = this.getValue(obj, ['ads_auth_http_log_yn'], 'log')
    this.port = this.getValue(obj, ['ads_auth_http_port'], 'port')
    this.use = this.getValue(obj, ['ads_auth_http_use_yn'], 'use')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(_.get(_.keys(_.pick(obj, [...arr])), 0, arr[0]))
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
}

export const state = () => ({
  authUdpData: {
    use: 0,
    auth_action: 1,
    auth_limit: 10000,
    auth_wait_time: 10,
    auth_wait_limit: 10,
    auth_wait_block: 0,
    auth_keep_time: 86400,
    auth_wait_action: 0,
    port: '',
    log: 1
  },
  authTcpData: {},
  authHttpData: {},
  authDnsData: {}
})

export const mutations = {
  initStore (state) {
    state.authUdpData = {}
  },
  getAuthUdp (state, res) {
    state.authUdpData = new UdpData(res).get()
  },
  getAuthTcp (state, res) {
    state.authTcpData = new TcpData(res).get()
  },
  getAuthHttpOpt (state, res) {
    state.authHttpData = new HttpData(res).get()
  },
  getAuthDns (state, res) {
    state.authDnsData = new DnsData(res).get()
  }
}

export const actions = {
  /**
   * UDP 제어 설정을 조회한다.
   * **/
  async getAuthUdpControlOpt ({commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result, reason} = await this.$axios.$get(`${cmApiPrefix}/adsprf/auth/udp-control/option/${id}`, {loading})
      if (code === 'ok') {
        res.result = new UdpData(result).get() || {}
        commit('getAuthUdp', result)
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * UDP 제어 설정을 편집한다
   * **/
  async setAuthUdpControlOpt ({state, commit, dispatch}, {id, params, loading = true, successAlert = false}) {
    const res = { code: 'ok' }
    try {
      const paramData = new UdpData(params).getApiParam()
      const {code, result} = await this.$axios.$put(`${cmApiPrefix}/adsprf/auth/udp-control/option/${id}`, paramData, {loading, successAlert})
      if (code === 'ok') {
        // this.dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * TCP 제어 설정을 조회한다.
   * **/
  async getAuthTcpControlOpt ({commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result, reason} = await this.$axios.$get(`${cmApiPrefix}/adsprf/auth/tcp-control/option/${id}`, {loading})
      if (code === 'ok') {
        res.result = new TcpData(result).get() || {}
        commit('getAuthTcp', _.cloneDeep(result) || {})
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * TCP 제어 설정을 편집한다
   * **/
  async setAuthTcpControlOpt ({state, commit}, {id, params, loading = true, successAlert = false}) {
    const res = {
      code: 'ok'
    }
    try {
      const paramsData = new TcpData(params).getApiParam()
      const {code, result} = await this.$axios.$put(`${cmApiPrefix}/adsprf/auth/tcp-control/option/${id}`, paramsData, {loading, successAlert})
      if (code === 'ok') {
        // this.dispatch('common/common/setIsChanged', true)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * HTTP 제어 설정을 조회한다.
   * **/
  async getAuthHttpControlOpt ({commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result, reason} = await this.$axios.$get(`${cmApiPrefix}/adsprf/auth/http-control/option/${id}`, {loading})
      if (code === 'ok') {
        res.result = new HttpData(result).get() || {}
        commit('getAuthHttpOpt', _.cloneDeep(result) || {})
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * HTTP 제어 설정을 편집한다
   * **/
  async setAuthHttpControlOpt ({state, commit, dispatch}, {id, params, loading = true, successAlert = false}) {
    const res = { code: 'ok' }
    try {
      const paramData = new HttpData(params).getApiParam()
      const {code, result} = await this.$axios.$put(`${cmApiPrefix}/adsprf/auth/http-control/option/${id}`, paramData, {loading, successAlert})
      if (code === 'ok') {
        // this.dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * DNS 제어 설정을 조회한다.
   * **/
  async getAuthDnsControlOpt ({commit}, {id, loading = true}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result, reason} = await this.$axios.$get(`${cmApiPrefix}/adsprf/auth/dns-control/option/${id}`, {loading})
      if (code === 'ok') {
        res.result = new DnsData(result).get() || {}
        commit('getAuthDns', result || {})
      } else {
        res.code = code
        res.reason = reason
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async setAuthDnsControlOpt ({state, commit, dispatch}, {id, params, loading = true, successAlert = false}) {
    const res = { code: 'ok' }
    try {
      const paramData = new DnsData(params).getApiParam()
      const {code, result} = await this.$axios.$put(`${cmApiPrefix}/adsprf/auth/dns-control/option/${id}`, paramData, {loading, successAlert})
      if (code === 'ok') {
        // this.dispatch('common/common/setIsChanged', true, {root: true})
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  /**
   * cli : INIT_AUTH_UDP_CONTROL_OPT
   * 설명 : 설정 정보 초기화
    */
  async resetAuthControlOpt ({state, dispatch, commit}, {id, controlName, loading = true, menuKey = ''}) {
    const res = {
      code: 'ok'
    }

    try {
      let headers = null
      if (menuKey) {
        headers = {
          'X-Gui-Menu': menuKey
        }
      }
      const {code} = await this.$axios.$put(`${cmApiPrefix}/adsprf/auth/${controlName}-control/option/${id}/init`, null, {loading, headers, successAlert: true})

      res.code = code
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
